import { apiClient, isApiError } from './apiClient';
import { IPropertySimulation } from 'types/PropertyTypes';

interface PaginatedResponse<T> {
  data: T[];
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

interface SimulationIdsResponse {
  ids: number[];
  simulations: Record<number, { id: number; good_reason: string | null; bad_reason: string | null }>;
}

/**
 * シミュレーション一覧を取得（ページネーション付き）
 */
export async function getList(page: number = 1, perPage: number = 50): Promise<PaginatedResponse<IPropertySimulation>> {
  return apiClient.get<PaginatedResponse<IPropertySimulation>>(`/property-simulations?page=${page}&per_page=${perPage}`);
}

/**
 * シミュレーション済み物件IDリストと理由を取得（軽量）
 */
export async function getAllIds(): Promise<SimulationIdsResponse> {
  return apiClient.get<SimulationIdsResponse>('/property-simulations/ids');
}

/**
 * シミュレーションを作成
 * @returns 作成されたシミュレーション。409の場合はnull（重複）
 */
export async function create(
  propertySaleHistoryId: number,
  goodReason: string,
  badReason: string,
): Promise<IPropertySimulation | null> {
  try {
    return await apiClient.post<IPropertySimulation>('/property-simulations', {
      property_sale_history_id: propertySaleHistoryId,
      good_reason: goodReason,
      bad_reason: badReason,
    });
  } catch (error) {
    if (isApiError(error) && error.status === 409) {
      return null;
    }
    throw error;
  }
}

/**
 * シミュレーションを更新（個別フィールド）
 */
export async function update(id: number, data: Partial<IPropertySimulation>): Promise<IPropertySimulation> {
  return apiClient.put<IPropertySimulation>(`/property-simulations/${id}`, data);
}

/**
 * シミュレーションを削除
 */
export async function del(id: number): Promise<void> {
  return apiClient.del(`/property-simulations/${id}`);
}
